<app-version-nav></app-version-nav>
<router-outlet></router-outlet>
